import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getDetailsKeyIndex, INSTITUTION_DETAILS_TYPE, type InstitutionDetailsKeyForDetailsType, type InstitutionDetailsType } from '@/features/institution/utils';
import { useDetailsNext } from './useDetailsNext';

const DETAILS_TYPE_NEXT_ROUTE_MAP = {
  [INSTITUTION_DETAILS_TYPE.ONBOARDING]: '/institution/onboarding/verification',
  [INSTITUTION_DETAILS_TYPE.FUTURES]: '/institution/futures/client-categorisation/treatment',
};

export const useDetailsFlowControl = <T extends InstitutionDetailsType>(detailType: T, currentKey: InstitutionDetailsKeyForDetailsType<T>) => {
  const { isLoading: isLoadingDetailsNext, data: detailsNext } = useDetailsNext(detailType);
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState(true);
  const isLoading = isLoadingDetailsNext || isPending;

  useEffect(() => {
    if (isLoadingDetailsNext || isPending === false) return;

    if (!detailsNext) {
      navigate(DETAILS_TYPE_NEXT_ROUTE_MAP[detailType], { replace: true });
    } else if (detailsNext.key !== currentKey && detailsNext.route) {
      const currentKeyIndex = getDetailsKeyIndex(detailType, currentKey);
      const nextKeyIndex = getDetailsKeyIndex(detailType, detailsNext.key);

      if (currentKeyIndex > nextKeyIndex) {
        navigate(detailsNext.route, { replace: true });
      }
    }

    setIsPending(false);
  }, [currentKey, detailsNext, detailType, isLoadingDetailsNext, isPending, navigate]);

  return { isLoading };
};
